"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _Panel = _interopRequireDefault(require("react-bootstrap/lib/Panel"));

var _CardDropdownMenu = _interopRequireDefault(require("./CardDropdownMenu"));

var _valueCheck = require("../internal/utils/valueCheck");

var _prefix = _interopRequireDefault(require("../prefix"));
/** Single-topic panels that summarize information */


var Card = function Card(_ref) {
  var dropdownOptions = _ref.dropdownOptions,
      dropdownProps = _ref.dropdownProps,
      header = _ref.header,
      htmlId = _ref.htmlId,
      className = _ref.className,
      children = _ref.children,
      other = (0, _objectWithoutProperties2["default"])(_ref, ["dropdownOptions", "dropdownProps", "header", "htmlId", "className", "children"]);

  var panelHeader = header && /*#__PURE__*/_react["default"].createElement("div", {
    className: "card__title"
  }, header);

  var hasDropdownOptions = (0, _valueCheck.hasValue)(dropdownOptions) && dropdownOptions.length > 0;
  return /*#__PURE__*/_react["default"].createElement(_Panel["default"], Object.assign({
    bsClass: "".concat(_prefix["default"], "panel"),
    id: htmlId,
    className: (0, _classnames["default"])(["card", hasDropdownOptions && "card-dropdown", className])
  }, other), header && /*#__PURE__*/_react["default"].createElement(_Panel["default"].Heading, null, /*#__PURE__*/_react["default"].createElement(_Panel["default"].Title, null, panelHeader), hasDropdownOptions && /*#__PURE__*/_react["default"].createElement(_CardDropdownMenu["default"], {
    htmlId: "".concat(htmlId, "-CardDropdownMenu"),
    dropdownOptions: dropdownOptions,
    dropdownProps: dropdownProps
  })), /*#__PURE__*/_react["default"].createElement(_Panel["default"].Body, null, children, !header && hasDropdownOptions && /*#__PURE__*/_react["default"].createElement(_CardDropdownMenu["default"], {
    htmlId: "".concat(htmlId, "-CardDropdownMenu"),
    dropdownOptions: dropdownOptions,
    dropdownProps: dropdownProps
  })));
};

Card.defaultProps = {
  dropdownOptions: undefined,
  header: undefined
};
var _default = Card;
exports["default"] = _default;